import {
	getImageConfig,
	richTextResolver,
} from "@website-builder/utilities-index";

export default (props, { globalVariableWithURL = [] }) => {
	const { image, title, about } = props;
	const imageConfig = getImageConfig(image);
	return {
		imageConfig,
		title,
		about: richTextResolver(about, globalVariableWithURL),
	};
};
